<template>
    <div class="d-content">
    <dashboard-content-nav :nav="navItems"/>
    <keep-alive>
      <component :is="currentComponent" :entity_index="entity_index"></component>
    </keep-alive>
    </div>
</template>
<script>
const nav_items = (entity_index) =>([ 
        // {
        //   type: "navitem",
        //   label: "IT Declaration",
        //   path:setPathFunction(entity_index,'itDeclaration')
        // },
        {
        type: "navitem",
         label: "IT Proof Submission",
         path:setPathFunction(entity_index,'itProofSubmission')
        },
      ])
      const setPathFunction = (entity_index,step_name, sub_step) => 
{
      return `/dashboard/${entity_index}/incomeTax/${step_name}`;
  }
  import itProofSubmission from "../itProofSubmission.vue";
  import itDeclaration from "../itDeclaration.vue";
  const mapNameToComponents = {
    "itDeclaration":itDeclaration,
    "itProofSubmission":itProofSubmission
  }

import dashboardContentNav from "@/components/dashboard/contentNav.vue";
export default {
  components: {
    dashboardContentNav,
  },
  props: ['sub_step','entity_index'],
  data() {
    return {
        navItems:[],
    };
  },
  created(){
      this.navItems = nav_items(this.entity_index);
  },
  computed:{
    currentComponent: function() {
        return mapNameToComponents[this.sub_step];
    },
  }
  ,methods:{
     async currentCallerFunction(){
       try{
        let assignResponse=await this.callerFunctionForSubmitItProof()
       }catch(err){

       }
     }
  }}
</script>
<style>
</style>